// extracted by mini-css-extract-plugin
export default {"root":"SectionExploreDestinations_root__av2rF"};